import { useQuery } from "react-query";
import { onError } from "./onError";
import { axios } from "../../lib/axios";
import moment from "moment";
import { useSelector } from "react-redux";

export function usePatientEncounterHistoryQuery({ startDate, endDate, patientId, onSuccess, practitionerId, orgId: orgIdOverride, ...props }) {
    const userOrgId = useSelector((state) => state?.auth?.user?.organizations?.[0]?.id);
    const isSuperAdmin = useSelector((state) => state?.auth?.user?.["cognito:groups"]?.includes("Super-Admin"));
    // Super admin on patient dashboard: use patient's orgId when provided; otherwise use user's org
    const orgId = isSuperAdmin && orgIdOverride ? orgIdOverride : userOrgId;
    const startDateISO = moment(startDate).startOf('day').valueOf();
    const endDateISO = moment(endDate).endOf('day').valueOf();
    const fetch = () => {
        if (!orgId) return Promise.resolve({ data: [] });
        if (practitionerId) return axios.get(`encounter/search?patientID=${patientId}&practitionerId=${practitionerId}&DateStart=${startDateISO}&DateEnd=${endDateISO}&status=finished&type=closed&orgId=${orgId}&getAll=false`);
        return axios.get(`encounter/search?patientID=${patientId}&DateStart=${startDateISO}&DateEnd=${endDateISO}&status=finished&type=closed&orgId=${orgId}&getAll=false`);
    };

    const query = useQuery(
        ["patient-encounter-history", startDate, endDate, patientId, orgId],
        () => fetch(),
        {
            select: (data) => {
                return data?.data?.filter(item => item.status === 'finished');
            },
            onSuccess,
            onError,
            ...props
        }
    );

    return { ...query }
}